// @flow

import OrdersFiltersFormContainer from './OrdersFiltersFormContainer'

export default OrdersFiltersFormContainer
